let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jE56l")).then(() => parcelRequire('33O9R'));